import React from "react";
import { ConfigProvider } from "antd";
import { router } from "./routes";
import { RouterProvider } from "react-router-dom";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import store from "./store";
import "./global.scss";
import "antd/dist/reset.css";

const themeConfig = {
  token: {
    colorPrimary: "#0B0C5C",
    colorPrimaryBg: "#F4E6D4",
    colorLink: "#000000",
  },
};

createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ConfigProvider theme={themeConfig}>
      <Provider store={store}>
        <RouterProvider router={router()} />
      </Provider>
    </ConfigProvider>
  </React.StrictMode>
);

// {
//   "title": "تصميم الشعارات",
//   "description": "",
//   "flowSteps": [
//       {"week": "1", "title": "تصميم الشعارات", "description": "...", "hoursNeeded": ""}
//   ],
//   "thumnil": "855dcdaaaca969856387d51f384ca625.png",
//   "courseCode": "002",
//   "coursePrerequisites": ".",
//   "educationalCredentialAwarded": ".",
//   "numberOfCredits": "0",
//   "courseRating": "4.9",
//   "author": "Golancer",
//   "trainer": "محمد الطويل",
//   "aboutTrainer": "محمد مهندس برمجيات ولديه 5 سنوات من الخبرة في تطوير  برمجيات الهواتف الذكية عمل كمهندس مستقل وبنى مشاريع لشركات وأفراد في دول متعددة مثل كندا والمملكة العربية السعودية.الدورات التدريبية",
//   "trainerImage": "ecea6ff5d3c3c6290cf9c53b08f6d2a3.jpeg",
//   "comments": [],
//   "likes": [],
//   "disLikes": [],
//   "timeRequired": "6 اشهر",
//   "courseViseos": [
//   { "stepTitle": "أنواع اللوقو 1", "steps": [
//       { "video": "", "videoDescription": "", "title": "أنواع اللوقو 1", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "أنواع اللوقو 2", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "انواع اللوقو 3", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "نصائح قبل البدء في تصميم اللوقو", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "التغذية البصرية والكلمات المفتاحية", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "الشعار الرمزي", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "اللوقو الحرفي 1", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "اللوقو الحرفي 2", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "اللوقو الكوفي", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "الخط الكوفي", "isFinished": false },
//       { "video": "", "videoDescription": "", "title": "الخط الكوفي - بناء الشبكة للقاعدة العامة", "isFinished": false }
//   ]}
//   ]
// }
